// @flow

import Resource from 'speed-js-core/src/api/Resource';
import type { UUID } from 'esm-web-pro/types/common';

export default class Point11Resource extends Resource {
    basePath: string = 'networks/points11/';

    searchPath: string = 'networks/search-points/';

    objectPath: string = 'networks/points11/{ident}/';

    _getSearchPath = () => this.searchPath;

    reorder(query: Object): Promise<Object> {
        return this.client._request(
            `${this._getBasePath()}reorder/`,
            'POST', query,
        ).then((response) => response.data);
    }

    connectedLines(id: UUID) {
        return this.client._request(`${this._getObjectPath(id)}connected_lines/`, 'GET')
            .then((response) => response.data);
    }

    connectToForks(id: UUID, query: { map: UUID }): Promise<Object> {
        return this.client._request(
            `${this._getObjectPath(id)}can_connect_to_forks/`,
            'GET', query,
        ).then((response) => response.data);
    }

    list(query: Object): Promise<Object> {
        return this.client._request(this._getSearchPath(), 'GET', query).then((response) => response.data);
    }
}
